import PropTypes from "prop-types"

import Button from "components/ui/button"
import { cn } from "styles/utils"

export const ActionBtn = ({ className = "", ...props }) => (
  <Button
    className={cn("text-14 mx-16 font-medium tracking-normal", className)}
    text
    underline
    variant="secondary"
    {...props}
  />
)

ActionBtn.propTypes = {
  className: PropTypes.string,
}

export const Text = ({ className = "", ...props }) => (
  <p
    className={cn(
      "text-14 tracking-tigher leading-16 mb-6 text-black",
      className
    )}
    {...props}
  />
)

Text.propTypes = {
  className: PropTypes.string,
}

export const ShipDate = ({
  className = "",
  holidayStyle = false,
  ...props
}) => (
  <span
    className={cn(
      "text-14 tracking-tigher leading-16 font-semibold text-black",
      holidayStyle && "text-sale-pink",
      className
    )}
    {...props}
  />
)

ShipDate.propTypes = {
  className: PropTypes.string,
  holidayStyle: PropTypes.bool,
}
